import { createContext } from 'react';

import { HeaderContextProps } from './Header.types';

export const HeaderContext = createContext({} as HeaderContextProps);
